import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { useEffect, useMemo, useState } from "react";
import { Moment } from "moment";
import FeatherIcon from "feather-icons-react";
import useApi from "../../../core/customhook/useApi";
import moment from "moment";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import Swal from "sweetalert2";
import Datatable from "../../../core/common/dataTable/index";
dayjs.extend(duration);


const RegularizationTeam = () => {
  const [empname, setEmpname] = useState("");
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [regu, setRegu] = useState([]);
  const [empdata, setEmpdata] = useState([])
  const [searchValue, setSearchValue] = useState<string>("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [managerInTime, setManagerInTime] = useState<any>(null);
  const [managerOutTime, setManagerOutTime] = useState<any>(null);
  const [managerReason, setManagerReason] = useState<string>("");
  const [managerHours, setManagerHours] = useState<string>("");
  const [count, setCount] = useState(0)
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const [selectedDateRange, setSelectedDateRange] = useState<{
    from: string;
    to: string;
  }>({
    from: moment().startOf('month').format("YYYY-MM-DD"),
    to: moment().endOf('month').format("YYYY-MM-DD"),
  });
  const [reguStatus, setReguStatus] = useState("")

  const handleStatusChange = (e: any) => {
    setReguStatus(e.target.value);
  };


  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (teamData?.success) {
      setEmpdata(teamData?.data)
    }
  }, [teamData])

  const {
    data: attendancereguData,
    loading: attendancereguLoading,
    error: attendancereguErrro,
  } = useApi("/api/get-team-regularization-details", {
    method: "POST",
    payload: {
      employee_id: searchValue,
      from: selectedDateRange.from,
      to: selectedDateRange.to,
      status: reguStatus
    },
    autoCall: true,
    dependencies: [reguStatus, selectedDateRange, searchValue, count],
  });
  useEffect(() => {
    if (attendancereguData?.success) {
      setRegu(attendancereguData?.data);
    }
  }, [attendancereguData]);

  const columns = [
    {
      title: "EmpID",
      dataIndex: "employee_id",
      render: (text: string) => (
        <Link to={all_routes.employeedetails}>{text}</Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Name",
      dataIndex: "employee_name",
      sorter: (a: any, b: any) => a.employee_name.localeCompare(b.employee_name),
    },

    {
      title: "Date",
      dataIndex: "attendance_regn_date",
      render: (text: string) => dayjs(text).format("D MMMM YYYY"), // e.g. 10 October 2025
      sorter: (a: any, b: any) =>
        dayjs(a.attendance_regn_date).unix() - dayjs(b.attendance_regn_date).unix(),
    },

    // {
    //   title: "Previous Shift",
    //   dataIndex: "PreviousShift",
    //   sorter: (a: any, b: any) =>
    //     a.PreviousShift.localeCompare(b.PreviousShift),
    // },
    {
      title: "InTime",
      dataIndex: "self_regn_in_time",
      sorter: (a: any, b: any) =>
        new Date(a.self_regn_in_time).getTime() - new Date(b.self_regn_in_time).getTime(),
    },
    {
      title: "OutTime",
      dataIndex: "self_regn_out_time",
      sorter: (a: any, b: any) =>
        new Date(a.self_regn_out_time).getTime() - new Date(b.self_regn_out_time).getTime(),
    },
    {
      title: "Hours",
      dataIndex: "self_regn_hours",
      sorter: (a: any, b: any) => a.self_regn_hours - b.self_regn_hours,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      sorter: (a: any, b: any) => a.reason.localeCompare(b.reason),
    },
    {
      title: "Status",
      dataIndex: "regularisation_status",
      render: (text: string) => {
        let badgeClass = "bg-danger"; // default red

        if (text.toLowerCase().includes("approved")) {
          badgeClass = "bg-success"; // green
        } else if (text.toLowerCase().includes("pending")) {
          badgeClass = "bg-warning"; // yellow
        }

        return <span className={`badge ${badgeClass}`}>{text}</span>;
      },
      sorter: (a: any, b: any) =>
        a.regularisation_status.localeCompare(b.regularisation_status),
    }
    ,
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Approve Icon */}
          <Link
            to="#"
            className="text-success"
            title="Approve"
            data-bs-toggle="modal"
            data-bs-target={`${record.regularisation_status === "PENDING" ? "#attendanceModal" : "#appOrRejectModal"}`}
            onClick={() => setSelectedRow(record)}
          >
            <i className="ti ti-eye" />
          </Link>
          {/* <Link
            to="#"
            className="text-danger"
            title="Disapprove"
            onClick={() => { }}
          >
            <i className="ti ti-circle-x" />
          </Link> */}
        </div>
      ),
    },
  ];
  const empcolumns = [
    {
      title: "EmpCode",
      dataIndex: "employee_id",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setSearchValue(record.employee_id);
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setSearchValue(record.employee_id);
            setEmpname(record.employee_name);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation", // Change From to designation
      sorter: (a: any, b: any) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Department",
      dataIndex: "department", // Change To to department
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Locatation",
      dataIndex: "branch_name", // Change To to branch_name
      sorter: (a: any, b: any) => a.branch_name.localeCompare(b.branch_name),
    },

  ];


  useEffect(() => {
    if (managerInTime && managerOutTime) {
      const inTime = dayjs(managerInTime, "HH:mm:ss");
      const outTime = dayjs(managerOutTime, "HH:mm:ss");

      const diff = outTime.diff(inTime);
      if (diff >= 0) {
        const dur = dayjs.duration(diff);
        const hours = String(dur.hours()).padStart(2, '0');
        const minutes = String(dur.minutes()).padStart(2, '0');
        setManagerHours(`${hours}:${minutes}`);
      } else {
        setManagerHours("00:00"); // or handle invalid case
      }
    } else {
      setManagerHours("");
    }
  }, [managerInTime, managerOutTime])

  const {
    data: attendancereguApprove,
    loading: attendancereguApproveLoading,
    error: attendancereguApproveErrro,
    callApi: ApprovedRecord
  } = useApi("/api/approved-regularization", {
    method: "POST",
    autoCall: false,
  });

  const handleApprove = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      employee_id: selectedRow.employee_id,
      regularization_id: selectedRow.regularization_id,
      attendance_regn_date: selectedRow?.self_regn_in_date,
      manager_regn_in_date: selectedRow?.self_regn_in_date,
      manager_regn_in_time: selectedRow?.self_regn_in_time,
      manager_regn_out_date: selectedRow?.self_regn_out_date,
      manager_regn_out_time: selectedRow?.self_regn_out_time,
      manager_reason: managerReason,
      manager_regn_hours: selectedRow?.self_regn_hours,
      status: "APPROVED",
    };

    try {
      const response = await ApprovedRecord(payload)
      if (response.success) {
        Swal.fire({
          icon: 'success',
          title: 'Approved',
          text: response?.message || 'The record has been successfully approved.',
          showConfirmButton: true,
        });
        setCount(count + 1)
        document.getElementById("closed_modal_Approved")?.click()
      }
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.message || 'Something went wrong while approving the record.',
      });
    }
  };

  const {
    data: attendancereguReject,
    loading: attendancereguRejectLoading,
    error: attendancereguRejectErrro,
    callApi: RejectdRecord
  } = useApi("/api/rejected-regularization", {
    method: "POST",
    autoCall: false,
  });

  const handleReject = async (e: React.FormEvent) => {
    e.preventDefault()
    const payload = {
      employee_id: selectedRow.employee_id,
      regularization_id: selectedRow.regularization_id,
      attendance_regn_date: selectedRow?.self_regn_in_date,
      manager_regn_in_date: selectedRow?.self_regn_in_date,
      manager_regn_in_time: selectedRow?.self_regn_in_time,
      manager_regn_out_date: selectedRow?.self_regn_out_date,
      manager_regn_out_time: selectedRow?.self_regn_out_time,
      manager_reason: managerReason,
      manager_regn_hours: selectedRow?.self_regn_hours,
      status: "REJECTED",
    };

    try {
      const response = await RejectdRecord(payload)
      console.log(response)
      if (response.success) {
        Swal.fire({
          icon: 'success',
          title: 'REJECTED',
          text: response?.message || 'The record has been successfully REJECTED.',
          showConfirmButton: true,
        });
        setCount(count + 1)
        document.getElementById("closed_modal_Approved")?.click()
      }
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.message || 'Something went wrong while approving the record.',
      });
    }
  };


  const formatDate = (dateString: any) => {
    if (!dateString) return "N/A";
    return dayjs(dateString).format("DD MMMM YYYY"); // e.g., 16 October 2025
  };

  const handleBulkApprove = async (rows: any[]) => {
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        title: "No rows selected",
        text: "Please select at least one row to approve.",
      });
      return;
    }

    const { value: reason } = await Swal.fire({
      title: "Enter reason for approval",
      input: "textarea",
      inputPlaceholder: "Enter reason here(optional)",
      inputAttributes: {
        "aria-label": "Enter reason",
      },
      showCancelButton: true,
      confirmButtonText: "Approve",
      cancelButtonText: "Cancel",
    });

    // if (!reason) {
    //   return;
    // }

    try {
      const payloads = rows.map((row) => ({
        employee_id: row.employee_id,
        regularization_id: row.regularization_id,
        attendance_regn_date: row.self_regn_in_date,
        manager_regn_in_date: row.self_regn_in_date,
        manager_regn_in_time: row.self_regn_in_time,
        manager_regn_out_date: row.self_regn_out_date,
        manager_regn_out_time: row.self_regn_out_time,
        manager_reason: reason || "",
        manager_regn_hours: row.self_regn_hours,
        status: "APPROVED",
      }));

      for (const payload of payloads) {
        await ApprovedRecord(payload);
      }

      Swal.fire({
        icon: "success",
        title: "Approved",
        text: `${rows.length} records have been approved successfully.`,
      });

      setCount(count + 1);

    } catch (error: any) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong while approving the records.",
      });
    }
  };


  const handleBulkReject = async (rows: any[]) => {
    console.log(rows)
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        title: "No rows selected",
        text: "Please select at least one row to reject.",
      });
      return;
    }

    const { value: reason } = await Swal.fire({
      title: "Enter reason for rejection",
      input: "textarea",
      inputPlaceholder: "Enter reason here(optional)",
      inputAttributes: {
        "aria-label": "Enter reason",
      },
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
    });

    // if (!reason) {
    //   return;
    // }

    try {
      const payloads = rows.map((row) => ({
        employee_id: row.employee_id,
        regularization_id: row.regularization_id,
        attendance_regn_date: row.self_regn_in_date,
        manager_regn_in_date: row.self_regn_in_date,
        manager_regn_in_time: row.self_regn_in_time,
        manager_regn_out_date: row.self_regn_out_date,
        manager_regn_out_time: row.self_regn_out_time,
        manager_reason: reason || "",
        manager_regn_hours: row.self_regn_hours,
        status: "REJECTED",
      }));

      for (const payload of payloads) {
        await RejectdRecord(payload);
      }

      Swal.fire({
        icon: "success",
        title: "Rejected",
        text: `${rows.length} records have been rejected successfully.`,
      });

      setCount(count + 1);

    } catch (error: any) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong while rejecting the records.",
      });
    }
  };


  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Team Regularization</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Team Regularization List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div style={{ position: "relative", width: "500px" }}>
                <input
                  type="text"
                  name="empname"
                  id="employeeSearch"
                  className="form-control pe-5"
                  placeholder="Type name / code"
                  style={{ width: "100%" }}
                  value={empname}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value;
                    setEmpname(value);
                    setSearchValue("");

                    if (value.trim()) {
                      const matches = empdata.filter((item: any) =>
                        item.employee_name.toLowerCase().includes(
                          value.toLowerCase()
                        )
                      );
                      setFilteredSuggestions(matches);
                      setShowSuggestions(true);
                    } else {
                      setFilteredSuggestions([]);
                      setShowSuggestions(false);
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    padding: "4px 8px",
                  }}
                  onClick={() => setModalOpen(true)}
                  data-bs-toggle="modal"
                  data-bs-target="#bs-example-modal-lg"
                >
                  <FeatherIcon icon="more-horizontal" size="16" />
                </button>
                {showSuggestions && filteredSuggestions.length > 0 && (
                  <ul
                    className="dropdown-menu show"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      position: "absolute",
                      zIndex: 1000,
                    }}
                  >
                    {filteredSuggestions.map((item, index) => (
                      <li
                        key={index}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSearchValue(item.employee_id);
                          setEmpname(item.employee_name);
                          setShowSuggestions(false);
                        }}
                      >
                        {item.employee_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges
                      onChange={(start: Moment, end: Moment) => {
                        setSelectedDateRange({
                          from: start.format("YYYY-MM-DD"),
                          to: end.format("YYYY-MM-DD"),
                        });
                      }}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>

                {/* <div>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleGoClick}
                  >
                    Go
                  </button>
                </div> */}
              </div>
            </div>
            <div className="card-header d-flex flex-wrap align-items-center gap-3 align-items-center justify-content-between">
              {/* Application Status Filters */}
              <div className="d-flex">
                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusAll"
                    name="applicationStatus"
                    value=""
                    checked={reguStatus === ""}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusAll">
                    All
                  </label>
                </div>

                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusPending"
                    name="applicationStatus"
                    value="PENDING"
                    checked={reguStatus === "PENDING"}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusPending">
                    Pending
                  </label>
                </div>

                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusApproved"
                    name="applicationStatus"
                    value="APPROVED"
                    checked={reguStatus === "APPROVED"}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusApproved">
                    Approved
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusRejected"
                    name="applicationStatus"
                    value="REJECTED"
                    checked={reguStatus === "REJECTED"}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusRejected">
                    Rejected
                  </label>
                </div>
              </div>
              {
                reguStatus === "PENDING" ?
                  <div className="d-flex gap-2">

                    <button
                      className="btn btn-primary"
                      onClick={() => handleBulkApprove(selectedRows)}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleBulkReject(selectedRows)}
                    >
                      Reject
                    </button>
                  </div>

                  : ""
              }
            </div>

            <div className="card-body p-0">
              <Table dataSource={regu} columns={columns} Selection={reguStatus === "PENDING" ? true : false} showSearchInput={true}
                rowKey={(record) => record.employee_id + record.attendance_regn_date} onRowSelect={(rows) => setSelectedRows(rows)} />

              {/* <Datatable
                dataSource={regu}
                columns={columns}
                Selection={reguStatus === "PENDING"}
                showSearchInput={true}
                rowKey={(record) => record.employee_id + record.attendance_regn_date}
                onRowSelect={(rows) => setSelectedRows(rows)} // <- pass callback
              />          */}
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className={`modal fade ${modalOpen ? "show" : ""}`}
        id="bs-example-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden={!modalOpen}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                src="/assets/img/logo/weconnectlogo.png"
                alt=""
                style={{ height: "50px" }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              />
            </div>
            <div className="modal-body">
              <div className="card-body p-0">
                <Table
                  dataSource={empdata}
                  columns={empcolumns}
                  Selection={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="attendanceModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-header">
                <h4 className="modal-title" id="exampleModalLgLabel">
                  Attendance Regularization
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closed_modal_Approved"
                />
              </div>

              <div className="modal-body">
                {/* Section: Employee Data */}
                <div className="mb-4  rounded">
                  <h6 className="fw-bold mb-3 text-secondary">Employee Filled Details</h6>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">In Date</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formatDate(selectedRow?.self_regn_in_date)}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">In Time</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedRow?.self_regn_in_time || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Out Date</label>

                      <input
                        type="text"
                        className="form-control"
                        value={formatDate(selectedRow?.self_regn_out_date)}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Out Time</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedRow?.self_regn_out_time || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Reason</label>
                      <textarea
                        className="form-control"
                        rows={3}
                        value={selectedRow?.reason || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Total Hours</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedRow?.self_regn_hours || ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                {/* Section: Manager Input */}
                <div className="border-top pt-4 mt-4">
                  <h6 className="fw-bold mb-3 text-secondary">Manager Review & Action</h6>

                  {/* <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Manager In Date</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedRow?.self_regn_in_date || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Manager In Time</label>
                      <TimePicker
                        className="form-control"
                        format="HH:mm:ss"
                        value={managerInTime}
                        onChange={(time) => setManagerInTime(time)}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Manager Out Date</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedRow?.self_regn_out_date || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Manager Out Time</label>
                      <TimePicker
                        className="form-control"
                        format="HH:mm:ss"
                        value={managerOutTime}
                        onChange={(time) => setManagerOutTime(time)}
                      />
                    </div>
                  </div> */}

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">Manager Remark</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter remarks or decision reason"
                        value={managerReason}
                        onChange={(e) => setManagerReason(e.target.value)}
                      />
                    </div>
                    {/* <div className="col-md-6">
                      <label className="form-label">Manager Approved Hours</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g. 08:00"
                        value={managerHours}
                        readOnly
                      />

                    </div> */}
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger me-2"
                  onClick={(e) => handleReject(e)}
                >
                  Reject
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={(e) => handleApprove(e)}
                >
                  Approve
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="appOrRejectModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Attendance Regularization
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closed_modal"
              />
            </div>

            <div className="modal-body">
              {/* Section: Employee Data */}
              <div className="mb-4  rounded">
                <h6 className="fw-bold mb-3 text-secondary">Employee Filled Details</h6>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">In Date</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatDate(selectedRow?.self_regn_in_date)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">In Time</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedRow?.self_regn_in_time || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Out Date</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatDate(selectedRow?.self_regn_out_date)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Out Time</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedRow?.self_regn_out_time || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Reason</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={selectedRow?.reason || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Total Hours</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedRow?.self_regn_hours || ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Section: Manager Input */}
              <div className="border-top pt-4 mt-4">
                <h6 className="fw-bold mb-3 text-secondary">Manager Review & Action</h6>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Manager In Date</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatDate(selectedRow?.manager_regn_in_date)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Manager In Time</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedRow?.manager_regn_in_time || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Manager Out Date</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatDate(selectedRow?.manager_regn_out_date)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Manager Out Time</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedRow?.manager_regn_out_time || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Manager Reason</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={selectedRow?.manager_reason || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Manager Approved Hours</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedRow?.manager_regn_hours || ""}
                      readOnly
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegularizationTeam;
